import { useToast } from '@cko/primitives';
import { useState, useEffect } from 'react';
import {
  TimeZone,
  getStoredTimeZone,
  getDefaultTimeZone,
  getTimeZoneFromValue,
  storeTimeZoneValue,
} from '@cko/dashboard-shared';
import { UserProfile } from './useGetUserProfile';
import { useUpdateTimeZone } from './useUpdateTimezone';

const storedTimeZone: TimeZone | undefined = getStoredTimeZone();
const defaultTimeZone: TimeZone = getDefaultTimeZone();

export const useTimeZone = (profile: UserProfile | undefined) => {
  const [timeZone, setTimeZone] = useState<TimeZone | undefined>(undefined);
  let profileTimezone: TimeZone | undefined;
  try {
    // if the is an issue load the default ( i.e. some users have incorrect timezones saved on their profile)
    profileTimezone = profile && getTimeZoneFromValue(profile.timezone);
  } catch {
    profileTimezone = getDefaultTimeZone();
  }

  const { showToast } = useToast();

  useEffect(() => {
    const currentStoredTimezone = getStoredTimeZone();
    if (profileTimezone && currentStoredTimezone === undefined) {
      storeTimeZoneValue(profileTimezone.value);
    }
  }, [profileTimezone]);

  const { mutateAsync: updateProfileTimezone } = useUpdateTimeZone();

  const updateTimeZone = async (newTimeZone: string) => {
    try {
      const newZone = getTimeZoneFromValue(newTimeZone);
      updateProfileTimezone({ timeZone: newTimeZone });
      storeTimeZoneValue(newTimeZone);
      setTimeZone(newZone);
      showToast('Time zone updated');
    } catch (error) {
      showToast('Time zone could not be updated at this time', { variant: 'alert' });
    }
  };

  return {
    updateTimeZone,
    timeZone: timeZone || storedTimeZone || profileTimezone || defaultTimeZone,
  };
};
